import ReportsApi from '../../../../API/shipment/reports-api';
import { PopUp, Row } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../constans';
import styles from './styles.module.scss';

const DeleteReportPopUp = ({ realization = {}, close = () => { } }) => {
  const clickDelete = async () => {
    await ReportsApi.deleteReport({ data: { reportId: realization.id } }).then(() => {
      close();
    });
  };

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
        <H2>
          Вы уверены что хотите удалить Отчёт {realization.market}/{realization.shop}?
        </H2>

        <Row style={{ marginTop: '30px' }}>
          <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={() => clickDelete()}>
            Удалить
          </Button>
          <Button type={TYPE_BUTTONS.GREY} onClick={close}>
            Отменить
          </Button>
        </Row>
    </PopUp>
  );
};

export default DeleteReportPopUp;
